import React from "react"
import { useCopyToClipboard } from "usehooks-ts"
import { Tooltip, IconButton } from "@mallardbay/lib-react-components"
import { faArrowUpFromBracket } from "@fortawesome/free-solid-svg-icons/faArrowUpFromBracket"
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck"
import { faCopy } from "@fortawesome/free-regular-svg-icons/faCopy"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import COPY from "~config/copy-constants"
import { useNativeShare } from "~utils/use-native-share"

interface Props {
    readonly value: string
}

export default function CopiableInputEndButton({ value }: Props) {
    const [copiedValue, copy] = useCopyToClipboard()
    const { isSupported: isNativeShareSupported, share } = useNativeShare()

    const copyTooltipLabel = copiedValue ? COPY.COPIED : COPY.COPY
    const copyIcon = copiedValue ? faCheck : faCopy

    const handleShare = async () => {
        await share({ url: value })
    }

    const handleCopy = async () => {
        await copy(value)
    }

    if (isNativeShareSupported) {
        return (
            <Tooltip label={COPY.SHARE.SHARE}>
                <IconButton
                    ariaLabel={COPY.SHARE.SHARE}
                    icon={<FontAwesomeIcon icon={faArrowUpFromBracket} />}
                    onClick={handleShare}
                />
            </Tooltip>
        )
    }

    return (
        <Tooltip label={copyTooltipLabel}>
            <IconButton
                ariaLabel={copyTooltipLabel}
                icon={<FontAwesomeIcon icon={copyIcon} />}
                onClick={handleCopy}
            />
        </Tooltip>
    )
}
